import { StrictMode } from "react";
import { PageProvider } from "./App/Context/PageProvider";
import ReactDOM from "react-dom/client";
import "../shared/init";
import App from "./App/App";
import "./utils/global";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <StrictMode>
    <PageProvider>
      <App />
    </PageProvider>
  </StrictMode>,
);

if (window.__ENV__.MODE === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              console.log("Nová verze je připravena. Prosím, obnovte stránku.");
            }
          });
        });
      })
      .catch(() => console.log("SW failed"));
  });
}
